import { bufferPolygon, initializeClipperFromBinary } from "@nova/calculate-clipper"
import { BufferError } from "@nova/constants"
import { defineTask } from "@nova/webworker-pool"

const clipperDistanceTooLargeMessage = "Cannot read properties of undefined (reading '0')"

const toBufferError = (error: unknown) =>
    error instanceof Error && error.message === clipperDistanceTooLargeMessage
        ? BufferError.DistanceTooLarge
        : BufferError.Unknown

export const createBuffer = defineTask({
    name: "createBuffer",
    wasm: ["clipper"],
    run: async (
        {
            xyCoordinates,
            bufferSizeInPixels,
        }: { xyCoordinates: [number, number][]; bufferSizeInPixels: number },
        { wasm }
    ) => {
        await initializeClipperFromBinary(wasm.clipper)
        try {
            return { data: bufferPolygon(xyCoordinates, bufferSizeInPixels) }
        } catch (error) {
            throw new Error(toBufferError(error))
        }
    },
})
